import linkifyHtml from "linkify-html";

window.App || (window.App = {});
window.App.util || (window.App.util = {});
window.App.util.linkifyHtml = linkifyHtml;

document.addEventListener("DOMContentLoaded", () => {
  util_conviertUrlToLinkInText('js-linkify');
});
